import React from 'react';
import { useState } from 'react';
import { purpleIcon } from '../assets';
import './WaitlistForm.css';

export const WaitlistForm = () => {
  
  // Controlled inputs for form
  const [profile, setProfile] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [webUrl, setWebUrl] = useState("");
  const [message, setMessage] = useState("");
  
  // Handles submission of form and errors if needed
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Webhook address to send form information on submit
  const handleSubmit = () => {
    const webHook = "https://api.retool.com/v1/workflows/249eb0ca-9e58-4f6e-8f81-a35c5628da34/startTrigger?workflowApiKey=retool_wk_0888ffad5566497187f743a56b728409";
    
    if (!firstName || !lastName || !email) {
      setErrorMessage("Please fill out the required fields.  ")
    } else if (!email.includes("@")) {
      setErrorMessage(errorMessage + "Email input invalid.")
    } else {
      const data = {
        first_name: firstName,
        last_name: lastName,
        profile: profile,
        email: email,
        website: webUrl,
        message: message,
      };
      
      fetch(`${webHook}`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({...data})
      })
      .then(resp => {
        if (resp.ok) {
          resp.json()
          .then(() => setSubmitted(true))
        } else {
          setSubmitError(true);
          setSubmitted(true);
        }
      });
    };
  };

  // Form body
  return (!submitted) ? (
    <div className="form-container">
        
        <div className="form-header">
          <img 
            src={purpleIcon} 
            className="form-icon" 
            alt="TrueRep" 
          />
          <h2>Join the waitlist...</h2>
        </div>
        
        <form className="form-content">
            <div className="form-row">
              <div className="form-block">
                <label>I am a/an...</label>
                <select
                  className="form-cell"
                  value={profile} 
                  onChange={(e) => setProfile(e.target.value)}
                >
                    <option>Brand</option>
                    <option>Talent Agent/Manager</option>
                    <option>Ad Agency</option>
                    <option>Other</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-block">
                <label><i>*</i>First Name</label>
                <input 
                  type="text"
                  className="form-cell" 
                  value={firstName} 
                  onChange={(e) => setFirstName(e.target.value)}
                  style={errorMessage && !firstName ? {outline: "3px solid #FF6F61"} : null}
                />
              </div>
              
              <div className="form-block">
                <label><i>*</i>Last Name</label>
                <input 
                  type="text"
                  className="form-cell" 
                  value={lastName} 
                  onChange={(e) => setLastName(e.target.value)}
                  style={errorMessage && !lastName ? {outline: "3px solid #FF6F61"} : null} 
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-block">
                <label><i>*</i>Email</label>
                <input 
                  type="email" 
                  className="form-cell"
                  value={email} 
                  placeholder="name@example.com"
                  onChange={(e) => setEmail(e.target.value)}
                  style={errorMessage && (!email || !email.includes("@")) ? {outline: "3px solid #FF6F61"} : null} 
                />
              </div>

              <div className="form-block">
                <label>Website</label>
                <input 
                  type="url" 
                  className="form-cell"
                  value={webUrl} 
                  onChange={(e) => setWebUrl(e.target.value)} 
                />
              </div>
            </div>

            
            <div className="form-message">
              <label>Leave a Message:</label>
              <textarea 
                className="form-cell"
                placeholder="Enter text..."   
                rows="6"
                value={message} 
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>
            
            <i>*Required</i>
            {errorMessage ? <i>{errorMessage}</i> : null}
        </form>
        
        <button className="form-submit" onClick={handleSubmit}>Submit</button>
    </div>
  ) : (
    // This section appears after form has been submitted
    <div className="submitted-message">
      <div className="form-header">
        <img 
          src={purpleIcon} 
          className="form-icon" 
          alt="TrueRep" 
        />
        <h2>{!submitError ? "Your submission was received!" : "Something went wrong with your submission!"}</h2>
      </div>
      <p>{!submitError ? "Thank you for your interest in TrueRep!" : "Please try again later."}</p>
    </div>
  );
};